import { createInstance } from "localforage"

export default createInstance({
  name: 'sam-calc-app'
})